import { Sidebar } from './Sidebar';
import { TopBar } from './TopBar';
import { useApp } from '@/context/AppContext';

export const AppLayout = ({ children }) => {
  const { sidebarCollapsed } = useApp();
  const sidebarW = sidebarCollapsed ? 'var(--sidebar-collapsed)' : 'var(--sidebar-width)';

  return (
    <div className="flex h-screen overflow-hidden" style={{ background: 'hsl(var(--background))' }}>
      <Sidebar />
      <div
        className="flex flex-col flex-1 min-w-0"
        style={{ marginLeft: sidebarW }}
      >
        <TopBar />
        <main
          className="flex-1 overflow-y-auto p-6"
          style={{ background: 'hsl(var(--background))' }}
        >
          {children}
        </main>
      </div>
    </div>
  );
};
